import {AxiosPromise} from 'axios';
import {SagaIterator} from 'redux-saga';
import {call, takeLatest} from 'redux-saga/effects';

import {PRODUCT_TYPES} from 'constants/product';
import {handlePushToSnackBar} from 'desktop/pages/cart/utils/pushToSnackBar';
import {ActionType} from 'types/reducers';

import {removeQuoteItem} from '../../reducers/quoteItems/quoteItems';

/**
 * Resolve CART.REMOVE_QUOTE_ITEM_FULFILLED
 */
export function* handleRemoveAccessory({meta}: ActionType<AxiosPromise, any>): SagaIterator {
    if (meta.type === PRODUCT_TYPES.ACCESSORY && meta.isNotice) {
        // @ts-expect-error typing issue in call method related to function overloading in handlePushToSnackBar
        yield call(handlePushToSnackBar, 'Removed', meta.name as string);
    }
}

/**
 * cartUIReactionsSaga
 */
export default function* cartUIReactionsSaga(): SagaIterator {
    yield takeLatest(`${removeQuoteItem.fulfilled}`, handleRemoveAccessory);
}
